/**
 * ViewKFSButton
 *
 * Generic button component that can be used to display any link/action.
 * Opens KFS modal by default, but can be extended for other purposes.
 *
 * Component ID: LOS_ViewKFSButton_442
 */

import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import KFSModal from '@/components/LOS/Caprion/KFSModal';

interface ViewKFSButtonProps {
  value?: any;
  onChange?: (data: any) => void;
  disabled?: boolean;
}

const ViewKFSButton: React.FC<ViewKFSButtonProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  const [isKFSModalOpen, setIsKFSModalOpen] = useState(false);

  return (
    <div className="flex justify-center -mt-2">
      <button
        onClick={() => setIsKFSModalOpen(true)}
        disabled={disabled}
        className="text-sm text-intellend-green hover:underline flex items-center gap-1.5 font-medium disabled:opacity-50 disabled:cursor-not-allowed py-0"
      >
        <FileText className="w-4 h-4" />
        View Key Fact Statement (KFS)
      </button>

      {/* KFS Modal - pass "dynamic" to indicate use dynamic offer API */}
      <KFSModal
        isOpen={isKFSModalOpen}
        onClose={() => setIsKFSModalOpen(false)}
        applicationId="dynamic"
      />
    </div>
  );
};

export default ViewKFSButton;
